import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import { Button } from "primereact/button";

import AdminOnly from "../../../../components/AdminOnly";
import CustomeButton from "../../../../components/Button/index";
import ToastMessage from "~/components/ToastMessage";
import EmploymentInformationForm from "./EmploymentInformationForm";
import useEditEmploymentInformation from "../../actions/useEditEmploymentInformation";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes-v2";

const EditEmploymentInformationForm = () => {
  const { id } = useParams();
  const {
    genstate,
    handleEnableEdit,
    handleUpdateEmploymentlInformation,
    handleDiscardEdit,
    handleChange,
    reset,
    toastRef,
    setAuditSidebarVisible,
  } = useEditEmploymentInformation();
  const auditLabels = () => ({
    update: "Employment Information Updated",
    create: `Employment Information Added`,
    delete: `Employment Information Deleted`,
  });
  return (
    <>
      <Card className="card-onboard">
        <div className="formgrid grid flex justify-content-between mb-4 align-items-center">
          <div className="">
            <p className="heading m-0 mb-2">Employment Information</p>
            <p className="description m-0">
              Defines the employee’s role, type, and status within the
              organization.
            </p>
          </div>
          <AdminOnly>
            <div className="flex gap-1">
              {genstate.isEdit ? (
                <>
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardEdit}
                  />
                  <CustomeButton
                    label={"Save Changes"}
                    variant="contained"
                    onClick={handleUpdateEmploymentlInformation}
                    loading={genstate?.isUpdating}
                    disabled={genstate?.isUpdating || genstate?.isSaveBtn}
                    className={`mr-2 access-btn  ${genstate?.isSaveBtn && "disable"}`}
                    iconPos="right"
                  />
                </>
              ) : (
                <>
                  <Button
                    className="edit-button"
                    onClick={() => setAuditSidebarVisible(true)}
                  >
                    View History
                    <span className="pi pi-history mb-1 ml-2" />
                  </Button>
                  <CustomeButton
                    label="Edit"
                    variant="contained"
                    className="mr-2 access-btn"
                    onClick={handleEnableEdit}
                    icon="pi pi-pencil"
                    iconPos="right"
                  />
                </>
              )}
            </div>
          </AdminOnly>
        </div>
        <div className="formgrid grid">
          <EmploymentInformationForm
            employmentInformation={genstate.geninfo}
            handleChange={handleChange}
            isLoading={!genstate.isDataAvailable}
            isEdit={genstate.isEdit}
            resetForm={reset}
            editForm={true}
          />
        </div>
        {genstate.isAuditSidebarVisible && (
          <AuditSidebar
            heading="Employment Information"
            endpoint={API_ROUTES.FETCH_EMPLOYEE_AUDIT}
            id={id}
            objectType="EMPLOYMENT_INFORMATION"
            labels={auditLabels}
            setSidebarToggle={setAuditSidebarVisible}
            sidebarToggle={genstate.isAuditSidebarVisible}
          />
        )}
        <ToastMessage ref={toastRef} />
      </Card>
    </>
  );
};

export default EditEmploymentInformationForm;
